function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "accelerate_svg__a",
  x1: "75.31%",
  x2: "25.946%",
  y1: "3.622%",
  y2: "94.701%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "accelerate_svg__b",
  x1: "75.31%",
  x2: "25.946%",
  y1: "44.418%",
  y2: "55.381%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "accelerate_svg__c",
  x1: "75.31%",
  x2: "25.946%",
  y1: "16.753%",
  y2: "82.044%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "accelerate_svg__d",
  x1: "75.31%",
  x2: "25.946%",
  y1: "16.752%",
  y2: "82.046%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#C9CDD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "accelerate_svg__e",
  x1: "0%",
  y1: "55.339%",
  y2: "55.339%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#00907F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#48D59F"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#accelerate_svg__a)",
  d: "M0 45.28c-.103 19.003 15.217 34.492 34.221 34.596 19.002.104 34.492-15.217 34.596-34.22.103-19.003-15.217-34.493-34.22-34.596h-.193C15.491 11.06.104 26.341 0 45.28"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M13.584 66.066C2.208 54.565 2.31 36.02 13.811 24.644c11.5-11.376 30.046-11.275 41.422.226 11.376 11.5 11.274 30.046-.227 41.422-11.5 11.376-30.046 11.274-41.422-.226"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#accelerate_svg__b)",
  d: "M26.725.86c-1.07 0-1.935.867-1.935 1.935V5.6c0 1.069.866 1.935 1.935 1.935h15.367A1.936 1.936 0 0044.028 5.6V2.795A1.936 1.936 0 0042.092.86H26.725z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#accelerate_svg__c)",
  d: "M52.975 9.151l-1.097 1.507a1.285 1.285 0 00.282 1.797l8.254 6.019a1.287 1.287 0 001.797-.283l1.098-1.505a1.287 1.287 0 00-.282-1.798L54.773 8.87a1.287 1.287 0 00-1.798.281"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#accelerate_svg__d)",
  d: "M13.845 8.87l-8.254 6.018a1.286 1.286 0 00-.282 1.798l1.098 1.505c.419.574 1.223.7 1.798.283l8.253-6.02c.574-.417.7-1.222.283-1.796L15.642 9.15a1.286 1.286 0 00-1.04-.528c-.264 0-.529.08-.757.247"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#accelerate_svg__e)",
  d: "M34.408 45.469L53.09 26.787a26.33 26.33 0 00-18.682-7.74V45.47z"
}));

function SvgAccelerate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69 80"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,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";
export { SvgAccelerate as ReactComponent };